import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';

import { updateRequestItemById } from 'redux/actions/request';

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({
    updateRequestItemById,
  }, dispatch),
});

export default connect(null, mapDispatchToProps);
